module.exports = __webpack_public_path__ + "static/media/icon-forward.5476f671.svg";